import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaHome, FaUserPlus, FaArrowLeft } from "react-icons/fa";
import { parseJWT } from "../../utils/jwtUtils";
import { FiHome } from "react-icons/fi";
import { MdArrowBackIosNew } from "react-icons/md";

const Footer = () => {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const navigate = useNavigate();
  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down
        setShowFooter(false);
      } else {
        // Scrolling up
        setShowFooter(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleHome = () => {
    navigate("/"); // or your home route
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      {/* 🔻 Bottom Fixed Navigation */}
      <div
        style={{
          transition: "transform 0.3s ease-in-out",
          transform: showFooter ? "translateY(0)" : "translateY(100%)",
        }}
        className="
    fixed
    bottom-0
    left-0
    right-0
    z-40

    block
    md:hidden

    bg-gradient-to-r
    from-[#0F172A]
    via-[#1E293B]
    to-[#273549]

    border-t
    border-yellow-500/20

    shadow-[0_-8px_25px_rgba(0,0,0,.45)]

    backdrop-blur-md

    px-6
    py-1
  "
      >
        <div className="flex items-center justify-between">
          {/* Home */}
          <button
            onClick={handleHome}
            className="
        flex
        flex-col
        items-center
        justify-center

        w-12
        h-10

        rounded-xl

        bg-gradient-to-b
        from-[#1E293B]
        to-[#273549]

        text-slate-300

        border
        border-transparent

        transition-all
        duration-300

        hover:text-[#FACC15]
        hover:border-yellow-500/30
        hover:shadow-[0_0_15px_rgba(250,204,21,.2)]
        hover:scale-105
      "
          >
            <FiHome size={22} />
          </button>

          {/* Back */}
          <button
            onClick={handleBack}
            className="
        flex
        flex-col
        items-center
        justify-center

        w-12
        h-10

        rounded-xl

        bg-gradient-to-b
        from-[#1E293B]
        to-[#273549]

        text-slate-300

        border
        border-transparent

        transition-all
        duration-300

        hover:text-[#FACC15]
        hover:border-yellow-500/30
        hover:shadow-[0_0_15px_rgba(250,204,21,.2)]
        hover:scale-105
      "
          >
            <MdArrowBackIosNew size={22} />
          </button>
        </div>
      </div>
    </>
  );
};

export default Footer;
